module.exports = __webpack_public_path__ + "static/media/bank.69d90f2f.svg";